import { cn } from '@/lib/utils'
import { cva } from 'class-variance-authority'
import {
  defineCvaVariants,
  extendCvaVariants,
} from 'component_library/utils/cvaVariants'

export const baseButtonCvaVariants = defineCvaVariants({
  baseClass:
    '~font-gibson ~inline-flex ~items-center ~justify-center ~gap-2  ~whitespace-nowrap ~rounded-2xs ~text-base ~font-medium ~ring-offset-background ~transition-colors focus-visible:~outline-none focus-visible:~ring-2 focus-visible:~ring-ring focus-visible:~ring-offset-2 disabled:~pointer-events-none disabled:~opacity-50 [&_svg]:~pointer-events-none [&_svg]:~shrink-0',
  config: {
    variants: {
      variant: {
        default:
          '~bg-primary ~text-primary-foreground hover:~bg-sunrise-80 ~font-semibold ~rounded-full',
        destructive:
          '~bg-destructive ~text-destructive-foreground hover:~bg-cherry-80',
        outline:
          '~border ~border-muted ~bg-background hover:~bg-grey-wash/40 hover:~text-accent-foreground',
        secondary: '~bg-secondary ~text-secondary-foreground hover:~bg-navy-80',
        ghost: '~bg-transparent hover:~bg-grey-wash/40 hover:~text-black',
        link: '~text-link ~bg-transparent ~underline-offset-4',
        shadowedOutline:
          '~border ~border-grey-wash ~bg-white ~shadow-[0px_4px_8px_0px_rgba(0,0,0,0.06)] ~flex ~gap-3 hover:~shadow-none hover:~bg-navy-10 ~rounded-full',
      },
      size: {
        default: '~h-12 ~py-3 ~px-8',
        sm: '~h-10 ~px-4',
        lg: '~h-14 ~px-8',
        icon: '~h-10 ~w-10',
        link: '~px-[0px] ~py-0',
        shadowedOutline: '~h-14 ~px-6 ~py-4',
      },
      fullWidth: {
        true: '~w-full',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
      fullWidth: false,
    },
  },
})

export const v2ButtonCvaVariants = extendCvaVariants(
  baseButtonCvaVariants,
  defineCvaVariants({
    baseClass: '',
    config: {
      variants: {
        variant: {
          default: cn(
            '~border-0 ~bg-primary ~text-primary-foreground hover:~bg-sunrise-80 ~rounded-full',
            '~font-medium sm:~font-semibold',
            '~transition-colors ~duration-300 ~ease-in-out',
            'focus:!~outline focus:!~outline-2 focus:!~outline-sky focus:!~outline-offset-[-2px]',
            'disabled:~bg-grey-wash disabled:~cursor-not-allowed'
          ),
          secondary: cn(
            '~border ~border-navy ~bg-white ~text-navy ~rounded-full',
            '~font-semibold',
            '~transition-colors ~duration-300 ~ease-in-out',
            'focus:!~outline focus:!~outline-2 focus:!~outline-navy focus:!~outline-offset-[-2px]',
            'disabled:~cursor-not-allowed'
          ),
        },
        size: {
          default: '~h-10 ~px-8 ~py-2',
          sm: '~h-12 ~px-8 ~py-[11px]',
        },
      },
      defaultVariants: {},
    },
  })
)

export const ButtonVariants = {
  base: cva(baseButtonCvaVariants.baseClass, baseButtonCvaVariants.config),
  v2: cva(v2ButtonCvaVariants.baseClass, v2ButtonCvaVariants.config),
} as const

export type ButtonVariantType = keyof typeof ButtonVariants
